import API from '@/api/api.js'
import Moment from 'moment';
import Qs from 'qs'

export default class OsmAPIList {
  constructor() {
    let api = new API();
    this.api = api;
  }
  /**
   * Start of Second Class Api Management - OSM GI policy  
   */

  getGITypeInfoSelections(success, error) {
    this.api.get('/osm/generalPolicy/typeSelection', {}, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }
  /** ---
   * Start of New GI Policy
   */
  getGIProductTypeList(success, error) {
    this.api.get('/osm/generalPolicy/types', {}, (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }

  getGIProductFields(productType, success, error) {
    this.api.get('/osm/generalPolicy/fields', [{
        "key": "type",
        "value": productType
      }],
      (json) => { success(json); },
      (err) => {
        error(err)
      })
  }

  createGIPolicy(policyDetails, success, error) {
    this.api.post('/osm/generalPolicy/create', policyDetails, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  confirmGIPolicy(policyDetails, success, error) {
    this.api.post('/osm/generalPolicy/confirm', policyDetails, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  sendOutGIPolicy(policyDetails, success, error) {
    this.api.post('/osm/generalPolicy/sendOut', policyDetails, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  saveGIPolicy(policyDetails, success, error) {
    this.api.post('/osm/generalPolicy/edit', policyDetails, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  rejectGIPolicy(policyID, success, error) {
    this.api.post('/osm/generalPolicy/reject', { ID: policyID }, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  inforceGIPolicy(policyDetails, success, error) {
    this.api.post('/osm/generalPolicy/inforce', policyDetails, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  deleteGIPolicy(policyID, success, error) {
    this.api.post('/osm/generalPolicy/delete', { ID: policyID }, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }


  companyReceiveGIPolicy(policyDetails, success, error) {
    this.api.post('/osm/generalPolicy/companyReceive', policyDetails, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  agentReceiveGIPolicy(policyDetails, success, error) {
    this.api.post('/osm/generalPolicy/agentReceive', policyDetails, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  customerReceiveGIPolicy(policyDetails, success, error) {
    this.api.post('/osm/generalPolicy/customerReceive', policyDetails, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }



  /** ---
   * End of New GI Policy
   */

  /**
   *  Start of GI List
   */

  searchGIList(searchValue, success, error) {
    this.api.get('/osm/generalPolicy', [{
      "key": "search",
      "value": searchValue
    }], (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  getGIList(params, success, error) {
    this.api.get('/osm/generalPolicy', params, (json) => {
      success(json);
    }, (err) => {
      error(err)
    })
  }

  getGIDetail(policyID, isConcat, success, error) {
    console.log(policyID, isConcat);
    this.api.get('/osm/generalPolicy/detail', [{
      "key": "ID",
      "value": policyID
    }, {
      "key": "concat",
      "value": isConcat
    }], (json) => {
      success(json);
    }, (err) => {
      error(err)
    })
  }

  /**
   *  End of GI List
   */

  /**
   *  start of GI cb
   */




  // params: ID, policyLapseDate
  lapseGI(params, success, error) {
    this.api.post('/osm/generalPolicy/lapse', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  // params: ID, policyEndDate, files, attachment
  surrenderGI(params, success, error) {
    this.api.post('/osm/generalPolicy/surrender', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  // params: ID, policyReinstateDate
  reinstateGI(params, success, error) {
    this.api.post('/osm/generalPolicy/reinstate', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  /**
   *  end of GI cb
   */


  /**
   *  start of life new
   */

  getLifeDetail(ID, isConcat, success, error) {
    var params = { ID: ID, concat: isConcat }
    this.api.get('/lifePolicy/detail', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  createLifePolicy(policyDetails, success, error) {
    this.api.post('/lifePolicy/new', policyDetails, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  confirmLifePolicy(policyDetails, success, error) {
    this.api.post('/lifePolicy/confirm', policyDetails, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  sendOutLifePolicy(policyDetails, success, error) {
    this.api.post('/lifePolicy/sendOut', policyDetails, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  saveLifePolicy(policyDetails, success, error) {
    this.api.post('/lifePolicy/edit', policyDetails, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  rejectLifePolicy(policyID, success, error) {
    this.api.post('/lifePolicy/reject', { ID: policyID }, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  inforceLifePolicy(policyDetails, success, error) {
    this.api.post('/lifePolicy/inforce', policyDetails, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  deleteLifePolicy(policyID, success, error) {
    this.api.post('/lifePolicy/delete', { ID: policyID }, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  companyReceiveLifePolicy(policyDetails, success, error) {
    this.api.post('/lifePolicy/companyReceive', policyDetails, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  agentReceiveLifePolicy(policyDetails, success, error) {
    this.api.post('/lifePolicy/agentReceive', policyDetails, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  customerReceiveLifePolicy(policyDetails, success, error) {
    this.api.post('/lifePolicy/customerReceive', policyDetails, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  addLifeRider(riderDetails, success, error) {
    this.api.post('/rider/create', riderDetails, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  removeLifeRider(riderID, success, error) {
    var params = { ID: riderID }
    this.api.post('/rider/delete', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  /**
   *  end of life new
   */

  /**
   *  Start of life List
   */

  getLifeList(params, success, error) {
    this.api.get('/lifePolicy', params, (json) => {
      success(json);
    }, (err) => {
      error(err)
    })
  }

  /**
   *  End of life List
   */

  /**
   *  start of life cb
   */




  // params: ID, policyLapseDate
  lapseLife(params, success, error) {
    this.api.post('/lifePolicy/lapse', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  // params: ID, policyEndDate, files, attachment
  surrenderLife(params, success, error) {
    this.api.post('/lifePolicy/surrender', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  // params: ID, policyReinstateDate
  reinstateLife(params, success, error) {
    this.api.post('/lifePolicy/reinstate', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  //params: entireNewLife fields
  transferInLife(params, success, error) {
    this.api.post('/lifePolicy/transferIn', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  // params: ID, files, attachment
  transferOutLife(params, success, error) {
    this.api.post('/lifePolicy/transferOut', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  // params: ID, files, attachment
  coolingOff(params, success, error) {
    this.api.post('/lifePolicy/coolingOff', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  // params: ID, premiumType, files, attachment
  changePremiumTypeLife(params, success, error) {
    this.api.post('/lifePolicy/changePremiumType', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }


  addLifeRider(riderDetails, success, error) {
    this.api.post('/rider/create', riderDetails, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  removeLifeRider(riderID, success, error) {
    var params = { ID: riderID }
    this.api.post('/rider/delete', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }
  /**
   *  end of GI cb
   */

  /**
   * Start of Service Request
   */
  getServiceRequestFields(params, success, error) {
    this.api.get('/osm/serviceRequest/fields', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  createServiceRequest(params, success, error) {
    this.api.post('/osm/serviceRequest/create', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  editServiceRequest(params, success, error) {
    this.api.post('/osm/serviceRequest/edit', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  getServiceRequestList(params, success, error) {
    this.api.get('/osm/serviceRequest', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  getServiceRequestDetail(params, success, error) {
    this.api.get('/osm/serviceRequest/detail', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  approveServiceRequest(params, success, error) {
    this.api.post('/osm/serviceRequest/approve', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  rejectServiceRequest(params, success, error) {
    this.api.post('/osm/serviceRequest/reject', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  getRiderFields(params, success, error) {
    this.api.get('/osm/serviceRequest/riderFields', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  getServiceRequestPolicyDetails(params, success, error) {
    this.api.get('/osm/serviceRequest/policy', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  /**
   * End of Service Request
   */

  /**
   * Start of Provider
   */

  getProviderList(params, success, error) {
    this.api.get('/provider', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  createProvider(params, success, error) {
    this.api.post('/provider/create', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  editProvider(params, success, error) {
    this.api.post('/provider/edit', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  deleteProvider(ID, success, error) {
    this.api.post('/provider/delete', { ID: ID }, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  /**
   * End of Provider
   */

  /**
   * Start of Product
   */

  getProductDetail(ID, success, error) {
    this.api.get('/product/detail', { ID: ID }, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  getProductList(params, success, error) {
    this.api.get('/product', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  editProduct(params, success, error) {
    this.api.post('/product/edit', params, (json) => {
      success(json);
    }, (error) => {
      error(err);
    })
  }

  createProduct(params, success, error) {
    this.api.post('/product/create', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  deleteProduct(ID, success, error) {
    this.api.post('/product/delete', { ID: ID }, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  createCommissionRate(params, success, error) {
    this.api.post('/product/createCommissionRate', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  editCommissionRate(params, success, error) {
    this.api.post('/product/editCommissionRate', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  /**
   * End of Product
   */

  /**
   * Start of Renewal
   */

  getRenewalList(params, success, error) {
    this.api.get('/renewal', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  renewLifePolicy(params, success, error) {
    this.api.post('/renewal/renewLifePolicy', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  /**
   * End of Renewal
   */

  /**
   * Start Policy Agent
   */
  editPolicyAgent(params, success, error) {
    this.api.post('/osm/policyAgent/edit', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  deletePolicyAgent(params, success, error) {
    this.api.post('/osm/policyAgent/delete', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  /**
   * End of Policy Agent
   */

  /**
   * Start Cliam
   */

  getClaimList(params, success, error) {
    this.api.get('/osm/claim', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  createClaim(params, success, error) {
    this.api.post('/osm/claim/new', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  rejectClaim(params, success, error) {
    this.api.post('/osm/claim/reject', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  approveClaim(params, success, error) {
    this.api.post('/osm/claim/approve', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  createClaimResult(params, success, error) {
    this.api.post('/osm/claim/createResult', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  completeClaim(params, success, error) {
    this.api.post('/osm/claim/complete', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  editClaimResult(params, success, error) {
    this.api.post('/osm/claim/editResult', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  getClaimDetail(params, success, error) {
    this.api.get('/osm/claim/detail', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  editClaim(params, success, error) {
    this.api.post('/osm/claim/edit', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }


  /**
   * End Cliam
   */
}



// WEBPACK FOOTER //
// ./src/api/Osm/apiList.js